import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { ConfigService } from '../../../../core/services/config.service';
import { RequestService } from '../../../../core/services/request.service';

import { ProductVariantDetails } from './details/product-variant-details.model';

@Injectable()
export class ProductVariantService {

    constructor(
        private configService: ConfigService,
        private requestService: RequestService
    ) { }

    delete(details: any): Observable<ProductVariantDetails> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.productVariants.delete.api;
        return this.requestService.post(url, details);
    }
    add(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.productVariants.add.api;
        return this.requestService.post(url, details);
    }
    edit(details: any): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.productVariants.edit.api;
        return this.requestService.post(url, details);
    }
    getProductVariantDetails(id: string): Observable<ProductVariantDetails> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.productVariants.details.api + '/' + id;
        return this.requestService.get(url);
    }

    getProducts(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.product.api;
        return this.requestService.get(url, { verbose: true });
    }
    getLanguages(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.productLanguage.api;
        return this.requestService.get(url, { verbose: true });
    }

    getDeliveryFormats(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.deliveryFormat.api;
        return this.requestService.get(url, { verbose: true });
    }

    getCertificateTypes(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.certyficateType.api;
        return this.requestService.get(url, { verbose: true });
    }

    getExamFulfillmentTypes(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.examFulfillmentType.api;
        return this.requestService.get(url, { verbose: true });
    }

    getAccessDurationTypes(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.productAccessDuration.api;
        return this.requestService.get(url, { verbose: true });
    }

    getFreightClassDict(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.productFreightClassId.api;
        return this.requestService.get(url);
    }

    getAccountDeterminationGroups(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.accountDeterminationGroup.api;
        return this.requestService.get(url);
    }

    getBulkActions(): any {
        return {
            key: 'id',
            actions: [
                { name: 'edit', label: 'Edit', icon: 'fa-pencil-square', show: (data) => data.length > 0 }
            ]
        };
    }

    bulkEdit(details: any) {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.productVariants.bulkEdit.api;
        return this.requestService.post(url, details);
    }

    getBaseFields() {
        let fields = [
            {
                key: 'name',
                label: 'Name',
                type: 'textbox',
                required: true
            }, {
                key: 'shortDescription',
                label: 'Short Description',
                type: 'textbox',
                maxlength: '40',
                required: true
            }, {
                key: 'longDescription',
                label: 'Long Description',
                type: 'textarea',
                required: false
            }, {
                key: 'product.id',
                label: 'Product',
                type: 'combobox-single-select',
                required: true,
                dictionaryUrl:
                    this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.product.api
            }, {
                key: 'language.id',
                label: 'Language',
                type: 'dropdown',
                required: true,
                dictionaryUrl:
                    this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.productLanguage.api
            }, {
                key: 'accountDeterminationGroup',
                label: 'Account Determination Group',
                type: 'dropdown',
                required: true,
                dictionaryUrl:
                    this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.accountDeterminationGroup.api
            }, {
                key: 'deliveryFormat.id',
                label: 'Delivery Format',
                type: 'dropdown',
                required: true,
                dictionaryUrl:
                    this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.deliveryFormat.api
            }, {
                key: 'certificateType.id',
                label: 'Certificate Type',
                type: 'dropdown',
                required: false,
                dictionaryUrl:
                    this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.certyficateType.api
            }, {
                key: 'examFulfillmentType.id',
                label: 'Exam Fulfillment Type',
                type: 'dropdown',
                required: false,
                dictionaryUrl:
                    this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.examFulfillmentType.api
            }, {
                key: 'fulfillmentTurnAroundTime',
                label: 'Fulfillment Turnaround Time (Hours)',
                type: 'radio',
                options: [
                    { key: 24, value: '24' },
                    { key: 48, value: '48' },
                    { key: 72, value: '72' }
                ]
            }, {
                key: 'lastOrderDate',
                label: 'End of Order Date',
                type: 'datetimepicker'
            }, {
                key: 'endOfLife',
                label: 'End of Service Date',
                type: 'datetimepicker'
            },
            {
                key: 'evaluationCopyAvailable',
                label: 'Evaluation Voucher Available',
                type: 'radio',
                required: false,
                options: [
                    { key: true, value: 'Yes' },
                    { key: false, value: 'No' }
                ],
            }
        ];
        return fields;
    };
    getSupplierFields() {
        let fields = [
            {
                key: 'supplier.id',
                label: 'ID',
                type: 'hidden',
                required: false
            }, {
                key: 'supplier.name',
                label: 'Name',
                type: 'textbox',
                required: true
            }, {
                key: 'supplier.sku',
                label: 'SKU',
                type: 'textbox',
                required: true
            }
        ];
        return fields;
    };
    getManufacturerFields() {
        let fields = [
            {
                key: 'manufacturer.id',
                label: 'ID',
                type: 'hidden',
                required: false
            }, {
                key: 'manufacturer.name',
                label: 'Name',
                type: 'textbox',
                required: true
            }, {
                key: 'manufacturer.sku',
                label: 'SKU',
                type: 'textbox',
                required: true
            }
        ];
        return fields;
    };
    getDeliveryFields() {
        let fields = [
            {
                key: 'delivery.freeReturn30Day',
                label: 'Free Return 30 Days',
                type: 'radio',
                required: false,
                options: [
                    { key: true, value: 'Yes' },
                    { key: false, value: 'No' }
                ],
                default: false
            }, {
                key: 'delivery.requiresVoucher',
                label: 'Voucher Required',
                type: 'radio',
                required: false,
                options: [
                    { key: true, value: 'Yes' },
                    { key: false, value: 'No' }
                ],
                default: false
            }, {
                key: 'delivery.accessDuration',
                label: 'Access Duration',
                type: 'numberbox'
            }, {
                key: 'delivery.accessDurationType.id',
                label: 'Access Duration Type',
                type: 'dropdown',
                required: false,
                dictionaryUrl:
                    this.configService.get('server').url +
                    this.configService.get('endpoints').agora.dictionary.productAccessDuration.api
            }, {
                key: 'delivery.freightClassId.id',
                label: 'Freight Class ID',
                type: 'dropdown',
                required: true,
                dictionaryUrl:
                    this.configService.get('server').url +
                    this.configService.get('endpoints').agora.dictionary.productFreightClassId.api
            }, {
                key: 'manualFulfillment',
                label: 'Manual Fulfillment',
                type: 'radio',
                options: [
                    { key: true, value: 'Yes' },
                    { key: false, value: 'No' }
                ],
                default: false
            }
        ];

        return fields;
    }
    getBaseDetailsFields() {
        let fields = [
            {
                key: 'name',
                label: 'Name',
                type: 'text'
            }, {
                key: 'sku',
                label: 'SKU',
                type: 'text'
            }, {
                key: 'shortDescription',
                label: 'Short Description',
                type: 'text'
            }, {
                key: 'longDescription',
                label: 'Long Description',
                type: 'textarea'
            }, {
                key: 'deliveryFormat.configValue',
                label: 'Delivery Format',
                type: 'text'
            }, {
                key: 'language.configValue',
                label: 'Language',
                type: 'text'
            }, {
                key: 'certificateType.configValue',
                label: 'Certificate Type',
                type: 'text'
            }, {
                key: 'product.name',
                label: 'Product',
                type: 'link',
                config: {
                    route: '/agora/product-data/products/{{keyRoute}}/details',
                    keyRoute: 'product.id'
                }
            }, {
                key: 'examFulfillmentType.configValue',
                label: 'Exam Fulfillment Type',
                type: 'text'
            }, {
                key: 'online',
                label: 'Online',
                type: 'map',
                map : {
                    true: 'Yes',
                    false: 'No'
                }
            }, {
                key: 'available',
                label: 'Available',
                type: 'map',
                map : {
                    true: 'Yes',
                    false: 'No'
                }
            }, {
                key: 'lastOrderDate',
                label: 'End of Order Date',
                type: 'date'
            }, {
                key: 'endOfLife',
                label: 'End of Service Date',
                type: 'date'
            }, {
                key: 'delivery.evaluationCopyAvailable',
                label: 'Evaluation Voucher Available',
                type: 'map',
                map : {
                    true: 'Yes',
                    false: 'No'
                }
        }
        ];
        return fields;
    };
    getSupplierDetailsFields() {
        let fields = [
            {
                key: 'supplier.name',
                label: 'Name',
                type: 'text'
            }, {
                key: 'supplier.sku',
                label: 'SKU',
                type: 'text'
            }
        ];
        return fields;
    };
    getManufacturerDetailsFields() {
        let fields = [
            {
                key: 'manufacturer.name',
                label: 'Name',
                type: 'text'
            }, {
                key: 'manufacturer.sku',
                label: 'SKU',
                type: 'text'
            }
        ];
        return fields;
    };
    getDeliveryDetailsFields(): Array<any> {
        let fields = [
            {
                key: 'delivery.freeReturn30Day',
                label: 'Free Return',
                type: 'map',
                map: {
                    true: 'Yes',
                    false: 'No'
                }
            },
            {
                key: 'delivery.requiresVoucher',
                label: 'Voucher Required',
                type: 'map',
                map: {
                    true: 'Yes',
                    false: 'No'
                }
            },
            {
                key: 'delivery.accessDuration',
                label: 'Access Duration',
                type: 'text'
            },
            {
                key: 'delivery.accessDurationType.configValue',
                label: 'Access Duration Type',
                type: 'text'
            },
            {
                key: 'delivery.freightClassId.configValue',
                label: 'Freight Class ID',
                type: 'text'
            },
            {
                key: 'delivery.manualFulfillment',
                label: 'Manual Fulfillment',
                type: 'map',
                map: {
                    true: 'Yes',
                    false: 'No'
                }
            }

        ];
        return fields;
    }
    getRendersDetailsFields(): Array<any> {
        let fields= [
            {
                key: (data: any) => {
                    return (data.renders && data.renders.length > 0 && data.renders[0].lastResizeStatus) ?
                        data.renders[0].lastResizeStatus.configValue : '';
                },
                label: 'Last Resize Status',
                type: 'text'
            },
            {
                key: (data: any) => {
                    return (data.renders && data.renders.length > 0 && data.renders[0]) ?
                        data.renders[0].largeImageUri : '';
                },
                label: 'Large Image Url',
                type: 'link',
                config: {
                    placeholder: 'Download'
                }
            },
            {
                key: (data: any) => {
                    return (data.renders && data.renders.length > 0 && data.renders[0]) ?
                        data.renders[0].mediumImageUri : '';
                },
                label: 'Medium Image Url',
                type: 'link',
                config: {
                    placeholder: 'Download'
                }
            },
            {
                key: (data: any) => {
                    return (data.renders && data.renders.length > 0 && data.renders[0]) ?
                        data.renders[0].smallImageUri : '';
                },
                label: 'Small Image Url',
                type: 'link',
                config: {
                    placeholder: 'Download'
                }
            }
        ];
        return fields;
    }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/product-variants/product-variant.service.ts